module.exports = __webpack_public_path__ + "static/media/06-Stuttgart@3x.9d0f6848.jpg";